import { X } from '@timelyapp/icons/solid-icons';
import classNames from 'classnames';
import React, { forwardRef } from 'react';
import { Tooltip as RadixTooltip } from '../../_radix-ui/tooltip/Tooltip';
import type { ElementProps } from '../../element/Element';
import type { TimelineItemPositioningProps } from '../Timeline.types';
import { timelineItemPositioning } from '../Timeline.utils';
import styles from './Timeline.Suggestion.module.scss';

export interface Props extends ElementProps {
  /** If specific, a small X will appear that can be clicked. */
  onDismiss?: () => void;
}

/**
 * "Calendar Suggestion" component for the Timeline
 * @see Timeline.tsx where this is re-exported
 */
const TimelineLaneSuggestionContainer = forwardRef<
  HTMLDivElement,
  Props & TimelineItemPositioningProps
>((props, ref) => {
  const { offsetPx, sizePx, orientation, onDismiss, style, children, ...rest } = props;
  const isDismissable = !!props.onDismiss;
  const dynamicStyles = timelineItemPositioning(props);

  const handleDismiss = (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    onDismiss?.();
  };

  return (
    <div
      {...rest}
      ref={ref}
      style={{ ...dynamicStyles, ...style }}
      className={classNames(styles.suggestionContainer, props.className)}
    >
      {isDismissable && (
        <RadixTooltip side="right" tooltip="Delete Suggestion">
          <button className={styles.rejectButton} onClick={handleDismiss}>
            <X width={15} height={15} />
          </button>
        </RadixTooltip>
      )}
      {children}
    </div>
  );
});
TimelineLaneSuggestionContainer.displayName = 'Timeline.Event';

/**
 * Wraps the Event on the Timeline
 */
export const TimelineSuggestion = Object.assign(TimelineLaneSuggestionContainer, {});

TimelineSuggestion.displayName = 'Timeline.TimelineSuggestion';
